import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=002aff3c&scoped=true&"
import script from "./Productos.vue?vue&type=script&lang=js&"
export * from "./Productos.vue?vue&type=script&lang=js&"
import style0 from "./Productos.vue?vue&type=style&index=0&id=002aff3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002aff3c",
  null
  
)

export default component.exports